import store from "../index.js";
import api from "../../utils/api";

export const modules = {
  store,
};

export const state = {
  _sherlockPoint: {
    sherlock_point_seq: -1,
    point_amount: 0,
    bonus_point_amount: 0,
  },
  _sherlockUserType: null,
};

export const mutations = {
  setPoint(state, points) {
    console.log("points points points :: ", points);
    state._sherlockPoint.sherlock_point_seq = points.sherlockPointSeq ?? -1;
    state._sherlockPoint.point_amount = points.pointAmount;
    state._sherlockPoint.bonus_point_amount = points.bonusPointAmount;
  },
  setUserType(state, userType) {
    state._sherlockUserType = userType;
  },
};

export const actions = {
  async acPointInfo({ commit }, payload) {
    const url = "/api/v1/sherlock/point/status";
    try {
      const result = await api.get(url, { params: payload });
      commit("setPoint", result?.data?.data);
    } catch (err) {
      return false;
    }
  },
  async acChargeSherlockPoint({}, { sherlock_point_seq, params }) {
    const url = `/api/v1/sherlock/point/${sherlock_point_seq}`;
    try {
      const result = await api.patch(url, params);
      return result?.data?.code === 0;
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },
  async acChargeSherlockBonusPoint({}, { sherlock_point_seq, params }) {
    const url = `/api/v1/sherlock/bounus-point/${sherlock_point_seq}`;
    try {
      const result = await api.patch(url, params);
      return result?.data?.code === 0;
    } catch (err) {
      return false;
    }
  },
  async acGetSherlockUserType({ commit }, userNo) {
    const url = "/api/v1/sherlock/user/type";
    try {
      const result = await api.get(url, { params: { sherlock_user_no: userNo } });
      const userType = result?.data?.data?.userType || "default";
      commit("setUserType", userType);
      return userType;
    } catch (err) {
      commit("setUserType", null);
      return null;
    }
  },
  async acUpdateSherlockUserType({}, { userNo, userType }) {
    const url = "/api/v1/sherlock/user/type";
    try {
      const result = await api.patch(url, {
        sherlock_user_no: userNo,
        user_type: userType,
      });
      return result?.data?.code === 0;
    } catch (err) {
      return false;
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
